// extracted by mini-css-extract-plugin
module.exports = {"addCustodianBtn":"AddCustodianButton_addCustodianBtn__2ZMUU"};